<template>
    <div>
        <div class="row mt-2" v-for="column in log.changed_columns" :key="column">
            <div class="col-md-9">
                <feather class="me-2" :type="getCommandColumnIcon(column, log)" />
                <strong>{{ userDisplayable }}</strong> {{ $tl("labels.clickAndCollect.commandLog.editBy") }} {{ getCommandColumnLabel(column, log) }}
                {{ $tl("labels.clickAndCollect.commandLog.order") }} :
                <strong>{{ getCommandColumnValueLabel(column, log) }}</strong>
            </div>
            <div class="col-md-3 text-end">
                <small>{{ createdAt }}</small>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";

import CommandColumnsEnum from "../../../../mixins/enums/click_and_collect/CommandColumnsEnum.js";

export default {
    data() {
        return {};
    },
    mixins: [CommandColumnsEnum],
    props: {
        log: {
            required: true,
            type: Object,
        },
    },
    methods: {},
    computed: {
        userDisplayable() {
            if (!this.log.user_id) return this.$tl("labels.booking.reservations.logs.client");
            if (!this.log.user) return this.$tl("labels.booking.reservations.logs.user");
            return `${this.log.user.firstname} ${this.log.user.lastname}`;
        },
        createdAt() {
            return moment(this.log.created_at).format("[le] DD/MM/Y [à] HH[h]mm");
        },
    },
};
</script>
